import { action } from "../common/Action"
import { messageAlert } from "../common/components/confirm";
import { ModelliClimaClient, ModelloClimaDto, ModelloClimaDataDto } from "../generated";
import { orderBy } from "lodash";

const service = new ModelliClimaClient();

class ModelliClimaActions {
    @action
    async add(caldaia: ModelloClimaDataDto) {
        const id = await service.add(caldaia);
        return { ...caldaia, id: +id } as ModelloClimaDto;
    }
    @action
    async update(id: number, caldaia: ModelloClimaDataDto) {
        await service.update(caldaia, id);
        return { ...caldaia, id: +id } as ModelloClimaDto;
    }
    @action
    async get(id: number) {
        return (await service.get(id))!;
    };
    @action
    async getAll() {
        return (await service.getAll())!;
    };
    @action
    async getCaldaieByMarca(marca: string) {
        return { marca, data: orderBy(await service.getCaldaieByMarca(marca, false), x => x.modello) };
    };

    @action
    async delete(idCaldaia: number) {
        const deleteOk = await service.deleteCaldaia(idCaldaia);
        if (!deleteOk) {
            messageAlert("Impossibile cancellare l'anagrafica caldaia in quanto è utilizzata su impianti registrati.", "Cancellazione modello caldaia")
        }
        return { deleteOk, idCaldaia }
    };
}
export default new ModelliClimaActions();